var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQiche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1698662026971,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3599,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 345.6C892.9536 345.6 890.0608 345.3184 887.1168 345.1648L947.2 422.4 947.2 422.4 947.2 652.8 947.2 704 947.2 780.8C947.2 809.088 924.288 832 896 832L793.6 832C765.312 832 742.4 809.088 742.4 780.8L742.4 704 281.6 704 281.6 780.8C281.6 809.088 258.688 832 230.4 832L128 832C99.712 832 76.8 809.088 76.8 780.8L76.8 704 76.8 652.8 76.8 422.4 76.8 422.4 146.1248 344.3968C140.288 345.1136 134.272 345.6 128 345.6 85.5808 345.6 51.2 328.3968 51.2 307.2 51.2 286.0032 85.5808 268.8 128 268.8 157.2352 268.8 182.3232 277.0688 195.3024 289.0752L281.6 192 768 192 838.144 282.1888C852.224 274.048 872.7808 268.8 896 268.8 938.4192 268.8 972.8 286.0032 972.8 307.2 972.8 328.3968 938.4192 345.6 896 345.6ZM153.6 473.6C153.6 501.888 193.7152 524.8 243.2 524.8 292.6848 524.8 332.8 501.888 332.8 473.6 332.8 445.312 292.6848 422.4 243.2 422.4 193.7152 422.4 153.6 445.312 153.6 473.6ZM724.992 243.2 324.608 243.2 230.4 371.2 819.2 371.2 724.992 243.2ZM780.8 422.4C731.3152 422.4 691.2 445.312 691.2 473.6 691.2 501.888 731.3152 524.8 780.8 524.8 830.2848 524.8 870.4 501.888 870.4 473.6 870.4 445.312 830.2848 422.4 780.8 422.4Z",
    "p-id": 3600
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiche);
export default __webpack_public_path__ + "static/media/qiche.35b6b006f9c64263549c47b5a4d4f21f.svg";
export { ForwardRef as ReactComponent };